import { UPDATE_LVT_REPORT, RESET_LVT_REPORT } from '../action-type';

export const updateLvtReport = (data) => ({
  type: UPDATE_LVT_REPORT,
  payload: data,
});

export const resetLvtReport = () => ({
  type: RESET_LVT_REPORT,
});